var _path, _path2, _path3, _path4, _path5, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6667 1.6C26.6667 0.7168 25.9426 0 25.0505 0H1.61616C0.72404 0 0 0.7168 0 1.6V14.4C0 15.2832 0.72404 16 1.61616 16H25.0505C25.9426 16 26.6667 15.2832 26.6667 14.4V1.6Z",
    fill: "#E5E7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 11.0681C3.33301 10.884 3.48225 10.7347 3.66634 10.7347H6.99967C7.18377 10.7347 7.33301 10.884 7.33301 11.0681V12.4014C7.33301 12.5855 7.18377 12.7347 6.99967 12.7347H3.66634C3.48225 12.7347 3.33301 12.5855 3.33301 12.4014V11.0681Z",
    fill: "#C2C4CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 11.0681C8.66699 10.884 8.81623 10.7347 9.00033 10.7347H12.3337C12.5178 10.7347 12.667 10.884 12.667 11.0681V12.4014C12.667 12.5855 12.5178 12.7347 12.3337 12.7347H9.00033C8.81623 12.7347 8.66699 12.5855 8.66699 12.4014V11.0681Z",
    fill: "#C2C4CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.0681C14 10.884 14.1492 10.7347 14.3333 10.7347H17.6667C17.8508 10.7347 18 10.884 18 11.0681V12.4014C18 12.5855 17.8508 12.7347 17.6667 12.7347H14.3333C14.1492 12.7347 14 12.5855 14 12.4014V11.0681Z",
    fill: "#C2C4CD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 11.0681C19.333 10.884 19.4822 10.7347 19.6663 10.7347H22.9997C23.1838 10.7347 23.333 10.884 23.333 11.0681V12.4014C23.333 12.5855 23.1838 12.7347 22.9997 12.7347H19.6663C19.4822 12.7347 19.333 12.5855 19.333 12.4014V11.0681Z",
    fill: "#C2C4CD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.33301,
    y: 3.89999,
    width: 4,
    height: 3.5,
    rx: 0.5,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.59728dc240a5179ce461db0839e3446c.svg";
export { ForwardRef as ReactComponent };